const COPY_TOAST_DURATION_MS = 2500;
const COPY_TOAST_HIDE_MS = 200;

export function showShareLinkCopiedToast(message = 'Ссылка скопирована'): void {
  document.querySelector('.share-copy-toast')?.remove();

  const toast = document.createElement('div');
  toast.className = 'share-copy-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.textContent = message;
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.classList.add('share-copy-toast--visible');
  });

  window.setTimeout(() => {
    toast.classList.remove('share-copy-toast--visible');
    window.setTimeout(() => toast.remove(), COPY_TOAST_HIDE_MS);
  }, COPY_TOAST_DURATION_MS);
}

export function getSharePageUrl(): string {
  return window.location.href;
}

export function getSharePageTitle(scope: ParentNode): string {
  const root =
    scope instanceof Element
      ? (scope.closest('.activity-page') ??
        scope.closest('.news-detail') ??
        scope.closest('.event-detail') ??
        scope.closest('[data-barba-namespace]'))
      : null;

  const titleEl =
    root?.querySelector<HTMLElement>(
      '[data-share-title], .activity-page__title, .news-page-title, .news-detail__main-content--title, .event-detail__title',
    ) ??
    document.querySelector<HTMLElement>(
      '.activity-page__title, .news-page-title, .news-detail__main-content--title, .event-detail__title',
    );

  return titleEl?.textContent?.trim() || document.title;
}

export function buildVkShareUrl(url: string, title?: string): string {
  const params = new URLSearchParams({ url });
  if (title) {
    params.set('title', title);
  }
  return `https://vk.com/share.php?${params.toString()}`;
}

/** @see https://dev.max.ru/help/deeplinks */
export function buildMaxShareUrl(text: string): string {
  return `https://max.ru/:share?text=${encodeURIComponent(text)}`;
}

export function buildShareMessage(url: string, title: string): string {
  return title ? `${title}\n${url}` : url;
}

export async function copyShareUrl(url: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return true;
    }
  } catch {
    // fallback below
  }

  try {
    const input = document.createElement('textarea');
    input.value = url;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(input);
    return ok;
  } catch {
    return false;
  }
}

export function initShareButtons(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-share-buttons]').forEach((block) => {
    const url = getSharePageUrl();
    const title = getSharePageTitle(block);
    const message = buildShareMessage(url, title);

    const vkLink = block.querySelector<HTMLAnchorElement>('[data-share-vk]');
    const maxLink = block.querySelector<HTMLAnchorElement>('[data-share-max]');
    const copyBtn = block.querySelector<HTMLButtonElement>('[data-share-copy]');

    if (vkLink) {
      vkLink.href = buildVkShareUrl(url, title);
    }

    if (maxLink) {
      maxLink.href = buildMaxShareUrl(message);
    }

    if (copyBtn && copyBtn.dataset.shareCopyBound !== 'true') {
      copyBtn.dataset.shareCopyBound = 'true';
      copyBtn.addEventListener('click', () => {
        void (async () => {
          const ok = await copyShareUrl(url);
          if (ok) {
            showShareLinkCopiedToast();
          } else {
            showShareLinkCopiedToast('Не удалось скопировать ссылку');
          }
        })();
      });
    }
  });
}
